// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"819":"css/configurator","826":"css/editor","830":"css/site"}[chunkId] + "." + __webpack_require__.h().slice(0, 6) + ".css";
};